<template>
  <div class="bq-contact">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="item in tabs" :key="item.title">
        <banner :cover="tabs[activeIndex].coverType" />
      </swiper-slide>
    </swiper>
    <BqTab :tabs="tabs" :activeIndex="activeIndex" @handleClick="handleClick">
      <Coo slot="Coo" />
      <Join slot="Join" />
    </BqTab>
  </div>
</template>

<script>
import { aboutData } from '../About/about.js';
import Banner from '@/components/Banner';
import { isWirelessDevice } from '../../../utils/utils.js';
import Coo from './Coo/index';
import Join from './Join/index';
import BqTab from '@/components/website_v3/Tab';
import { loadMap } from '@/utils/loadMap';
// import setSpm from '@alife/set-spm';

export default {
  name: 'contact',

  components: {
    BqTab,
    Join,
    Coo,
    Banner,
  },

  data() {
    return {
      swiperOptions: {},
      activeIndex: parseInt(this.$route.query.id || '0'),
      isMobile: false,
      aboutData,
      tabs: [
        {
          title: '合作咨询',
          slot: 'Coo',
          coverType:
            'https://img.alicdn.com/tfs/TB1CGbzEhD1gK0jSZFsXXbldVXa-1920-380.png',
        },
        {
          title: '加入我们',
          slot: 'Join',
          coverType:
            'https://img.alicdn.com/tfs/TB1OhPAEeT2gK0jSZFvXXXnFXXa-1920-380.png',
        },
      ],
    };
  },

  watch: {
    $route: {
      handler() {
        this.activeIndex = parseInt(this.$route.query.id);
        this.sendSpm();
        // console.log(this.activeIndex);
      },
      deep: true,
    },
  },

  mounted() {
    this.sendSpm();
    const longitude = '119.99260';
    const latitude = '30.276894';

    loadMap('681ee10b24816895866d19afee735956')
      .then(([AMap, AMapUI]) => {
        const map = new AMap.Map('container', {
          zoom: 17, //级别
          center: [longitude, latitude], //中心点坐标
          // viewMode: '3D', //使用3D视图
        });

        AMapUI.loadUI(['overlay/SimpleMarker'], SimpleMarker => {
          const theme = 'fresh';

          const marker = new SimpleMarker({
            //前景文字
            iconLabel: {
              innerHTML: '扁鹊',
              style: {
                color: '#fff',
              },
            },
            //图标主题
            iconTheme: theme,
            //背景图标样式
            iconStyle: 'darkblue',
            //...其他Marker选项...，不包括content
            title: '浙富西溪堂1号楼',
            map: map,
            label: {
              offset: new AMap.Pixel(40, 10),
              content: `<view class="marker-label">浙富西溪堂1号楼</view>`,
            },
          });

          marker.on('click', function() {
            marker.markOnAMAP({
              name: '浙富西溪堂1号楼',
              position: marker.getPosition(),
            });
          });
        });

        map.on('click', function(e) {
          console.log(e);
        });
      })
      .catch(err => {
        console.log(err);
      });
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },

  methods: {
    sendSpm() {
      const spma = 'a2o2ij';
      const spmbArr = ['14898923', '14898926'];
      const index = parseInt(this.$route.query.id);
      const spmb = spmbArr[index];
      console.log(`${spma}.${spmb}`);
      // setSpm(`${spma}.${spmb}`);
    },
    handleClick(index) {
      this.activeIndex = index;
      this.swiper.slideTo(index);
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
